var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMsAll = function SvgMsAll(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(122 444)",
    fill: "red",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_27",
    "data-name": "Mask Group 27",
    transform: "translate(-122 -444)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_people_24px",
    d: "M15.6,10.839a2.92,2.92,0,1,0-2.92-2.92A2.907,2.907,0,0,0,15.6,10.839Zm-7.786,0a2.92,2.92,0,1,0-2.92-2.92A2.907,2.907,0,0,0,7.812,10.839Zm0,1.946C5.545,12.786,1,13.924,1,16.192V28.625H17.625l-3-12.433C14.625,13.924,10.08,12.786,7.812,12.786Zm7.786,0c-.282,0-.6.019-.944.049a4.107,4.107,0,0,1,1.917,3.358l3,12.433h2.839V16.192C22.411,13.924,17.866,12.786,15.6,12.786Z",
    transform: "translate(122.495 446.538)",
    fill: "#25556e"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMsAll);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ms_all.a93665be1691d3683431637c9e825fde.svg";